/**
 * @author <xinghanhu@clubfactory.com>
 */
import React from 'react';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import Icon from '../icon/index';
class Drawer extends React.Component {
    constructor(props) {
        super(props);
        this.maskClick = () => {
            const { maskClose } = this.props;
            if (maskClose) {
                this.close();
            }
        };
        this.close = () => {
            this.setState({
                visible: false,
                hidding: true,
            });
            setTimeout(() => {
                this.setState({
                    hidding: false,
                });
                if (this.props.closeCallBack) {
                    this.props.closeCallBack();
                }
            }, 300);
        };
        this.state = {
            visible: false,
            hidding: false,
        };
        if (props.mountToBoday && document && document.createElement) {
            this.el = document.createElement('div');
            this.el && document.body.appendChild(this.el);
        }
    }
    componentDidMount() {
        this.setState({
            visible: this.props.visible,
        });
    }
    componentWillUnmount() {
        if (document) {
            this.el && document.body.removeChild(this.el);
        }
    }
    componentDidUpdate(preProps) {
        if (this.props.visible !== preProps.visible &&
            this.props.visible !== this.state.visible) {
            if (!this.props.visible) {
                this.close();
            }
            else {
                this.setState({
                    visible: this.props.visible,
                });
                setTimeout(() => {
                    if (this.props.showCallBack) {
                        this.props.showCallBack();
                    }
                }, 300);
            }
        }
    }
    render() {
        const { visible, hidding } = this.state;
        const { placement, children, showClose, className, zIndex, title, mountToBoday } = this.props;
        const stylezIndex = visible || hidding ? zIndex : -1;
        const drawerCls = classnames('cfm_drawer', `cfm_drawer_${placement}`, {
            'cfm_drawer_hidden': !(visible || hidding),
        }, {
            'cfm_drawer_hidding': hidding,
            'cfm_drawer_open': visible,
        }, className);
        const wrapperCls = classnames('cfm_drawer_wrapper', {
            'cfm_d_show': visible,
            'cfm_d_hidden': !visible,
        });
        const drawerContent = <div style={{ zIndex: stylezIndex }} className={drawerCls}>
      <div className='cfm_drawer_mask' onClick={this.maskClick}/>
      <div className={wrapperCls}>
        {visible && showClose ? <div className='cfm_drawer_close' onClick={this.close}>
            <Icon type='close'/>
          </div> : null}
        <div className='cfm_drawer_content'>
          {title ? <div className='cfm_drawer_title'>{title}</div> : null}
          <div className='cfm_drawer_body'>{children}</div>
        </div>
      </div>
    </div>;
        if (mountToBoday && this.el) {
            return ReactDOM.createPortal(drawerContent, this.el);
        }
        else if (!mountToBoday) {
            return drawerContent;
        }
        else {
            return null;
        }
    }
}
Drawer.defaultProps = {
    visible: false,
    placement: 'bottom',
    showClose: true,
    maskClose: true,
    zIndex: 1000,
    title: '',
    mountToBoday: true,
};
export default Drawer;



// WEBPACK FOOTER //
// ./components/drawer/index.tsx